/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, useState } from "react";
import { connect } from 'react-redux';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "reactstrap";
import './styles.scss';
import { sendVerificationCode, verify, changePassword ,resetPassword,setPassword, logout} from '../../actions/usersActions'; 
import { verifyCode } from "../../actions/loginActions"; 
import Stepper from 'react-stepper-horizontal';
import { Fade } from 'reactstrap';
import InputVerificationCode from '../../components/InputVerificationCode';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import logo from '../../assets/img/brand/new-logo.png';
import InputEmail from "../../components/InputEmail";
const ButtonLoader = require('reactstrap-button-loader').default;

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      password_repeat: "",
      phone: "",
      phone2: '',
      email: "",
      emailOrPhone:"",
      emailError: false,
      showErrorMessage: false,
      countryCode: "+90",
      verification_code: "",
      showModal: false,
      modalMessage: "",
      activeStep: this.props.location.step && this.props.location.step === 'activation' ? 1 : 0
    }
  }

  toggleModal = (modalMessage) => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      modalMessage
    }));
  }

  changeCountryCode = (e) => {
    this.setState({ countryCode: e, phone2: this.state.phone })
}

  /**
   * verification code request
   */
  onClickGetVerificationCode = (e) => {
    this.setState({ showErrorMessage: true });
    if (!this.state.emailError && this.state.emailOrPhone){
      e.preventDefault();
      this.props.resetPassword(this.state.emailOrPhone).then(res => {
        this.setState({ activeStep: 1 });
      }).catch(error => {
        if (error.message && error.message === "USER_NOT_FOUND") {
          this.toggleModal(this.props.t('forgetpassword.phone_not_exists'));
          this.setState({ showErrorMessage: false });
        } else if (error.responseCode && error.responseCode === "E15") {
          this.toggleModal(this.props.t('forgetpassword.request_expired'));
        }  else {
          this.toggleModal(this.props.t('server_error'));
        }
      });
    }else {
      this.toggleModal(this.props.t('forgetpassword.email_verification'));
    }
  }

  /**
   * verification process
   */
  onClickVerification = (e) => {
    e.preventDefault();
    if (!this.state.verification_code.trim()
    || this.state.verification_code.trim().length === 0
    || this.state.verification_code.indexOf('_') > -1) {
    this.toggleModal(this.props.t('fill_alert'));
    return;
  }
    this.props.verifyCode({ emailOrPhone: this.state.emailOrPhone, verificationCode: this.state.verification_code }).then((res) => {
      localStorage.setItem("token", res.token);
      this.setState({ activeStep: 2 });
    }).catch(error => {
      if (error.message && error.message === "VERIFICATION_CODE_EXPIRED") {
        this.toggleModal(this.props.t('resetpassword.verification_code_expired'));
      }
      else if (error.message && error.message === "INVALID_VERIFICATION_CODE") {
        this.toggleModal(this.props.t('resetpassword.verification_code_wrong'));
      }
      else if (error.message && error.message === "EXCEED_VERIFICATION_ATTEMPTS") {
        this.toggleModal(this.props.t('resetpassword.verification_exceed_attempts'));
      }
      else {
        this.toggleModal(this.props.t('server_error'));
      }
    })  
  }

  /**
  * completes reset password process
  */
  onClickComplete = (e) => {
    e.preventDefault();
    if (this.state.password.trim().length === 0
      || this.state.password_repeat.trim().length === 0) {
      this.toggleModal(this.props.t('fill_alert'));
      return;
    }

    if (this.state.password !== this.state.password_repeat) {
      this.toggleModal(this.props.t('resetpassword.passwords_not_match'));
      return;
    }

    this.props.setPassword({ emailOrPhone: this.state.emailOrPhone, newPassword: this.state.password }).then(() => {
      this.props.logout();
      this.setState({ activeStep: 3 });
    }).catch(error => {
      if (error.message && error.message === "INVALID_PASSWORD_FORMAT") {
        this.toggleModal(this.props.t('resetpassword.password_valide'));
      } 
      else {
        this.toggleModal(this.props.t('server_error'));
      }
    });
  }

  /**
   * navigates to the login page
   */
  onClickLogin = (e) => {
    e.preventDefault();
    this.props.history.push('/login');
  }

  /**
   * when text in inputs change it pass text to the state 
   */
 
  onChangeInputs = (e) => {
    this.setState({ [e.target.name]: e.target.value.trim() });
  }
  
  onChangeEmailError = (e) => {
    this.setState({emailError: e});
  }

  /**
   * renders registration form elements
   */
  _renderForgetPasswordForm() {
    return (<Fade>
      <Form onSubmit={this.onClickGetVerificationCode}>
      <InputEmail setEmailError={this.onChangeEmailError}  className="mb-4" placeholder={this.props.t('resetpassword.email_verification')} values={this.state.emailOrPhone} name="emailOrPhone" onChange={this.onChangeInputs} />
      {this.state.showErrorMessage &&this.state.emailError && (
          <Alert color="danger">
            <p className="mb-0">{this.props.t('resetpassword.email_regex_error')}</p>
          </Alert>
          )}
      <ButtonLoader color="success" block loading={this.props.loading} onClick={this.onClickGetVerificationCode}>{this.props.t('resetpassword.next_step')}</ButtonLoader>
      </Form>
    </Fade>);
  }

  /**
   * renders activation form elements
   */
  _renderActivationForm() {
    return (<Fade>
      <Form onSubmit={this.onClickVerification}>
        <Alert color="secondary">
          <p className="mb-0">{this.props.t('resetpassword.verification_message')}</p>
        </Alert>
        <InputVerificationCode  name="verification_code" placeholder={this.props.t('resetpassword.verification_code')} onChange={(e) => this.onChangeInputs(e)}  />
        <ButtonLoader color="success" block loading={this.props.loading} onClick={this.onClickVerification}>{this.props.t('resetpassword.next_step')}</ButtonLoader>
      </Form>
    </Fade>);
  }

  /**
  * renders set password form elements
  */
  _renderSetPasswordForm() {
    return (<Fade>
      <Form onSubmit={this.onClickComplete}>
        <InputGroup className="mb-3">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className="icon-lock"></i>
            </InputGroupText>
          </InputGroupAddon>
          <Input name="password" type="password" placeholder={this.props.t('password')} autoComplete="ontime-password" onChange={this.onChangeInputs} />
        </InputGroup>
        <InputGroup className="mb-3">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className="icon-lock"></i>
            </InputGroupText>
          </InputGroupAddon>
          <Input name="password_repeat" type="password" placeholder={this.props.t('password_repeat')} autoComplete="ontime-password" onChange={this.onChangeInputs} />
        </InputGroup>
        <ButtonLoader color="success" block loading={this.props.loading} onClick={this.onClickComplete}>{this.props.t('resetpassword.change_password')}</ButtonLoader>
      </Form>
    </Fade>);
  }

  /**
  * renders success alert
  */
  _renderSuccessAlert() {
    return (<Alert color="success">
      <h4 className="alert-heading">{this.props.t('success')}</h4>
      <p> {this.props.t('resetpassword.change_password_success')} </p>
    </Alert>);
  }

  /**
  * renders stepper elements
  */
  _renderStepper() {
    return (<div className="stepper-wrapper">
      <Stepper
        steps={[{ title: this.props.t('resetpassword.step_1') }, { title: this.props.t('resetpassword.step_2') }, { title: this.props.t('resetpassword.step_3') }]}
        activeStep={this.state.activeStep}
        completeColor="#10BF65"
      />
    </div>);
  }

  /**
   * renders form container - card
   */
  _renderFormContainer() {
    return (
      <React.Fragment>
        <Fade>
          <Row className="justify-content-center">
            <Col xs="12" md="8" lg="6" className="logo-col">
              {/* <img src={ontime_logo} className="logo-ontime" /> */}
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs="12" md="8" lg="6">
              <CardGroup>
                <Card className="p-3">
                  <CardBody>
                    <center><img src={logo} height="100"></img></center>
                    &emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;
                    <center><h1>{this.props.t('resetpassword.title')}</h1>
                    {this.state.activeStep === 0 ? <p className="text-muted">{this.props.t('resetpassword.subtitle')}.</p> : ""}
                    </center>
                    {this._renderStepper()}
                    {this.state.activeStep === 0 ? this._renderForgetPasswordForm() : ""}
                    {this.state.activeStep === 1 ? this._renderActivationForm() : ""}
                    {this.state.activeStep === 2 ? this._renderSetPasswordForm() : ""}
                    {this.state.activeStep === 3 ? this._renderSuccessAlert() : ""}
                  </CardBody>
                  <div>
                    <Button color="link" onClick={this.onClickLogin}>&lt;&lt; {this.props.t('login.login')}</Button>
                  </div>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Fade>
      </React.Fragment>)
  }

  /**
   * renders modal
   */
  _renderModal() {
    return (<Modal isOpen={this.state.showModal} modalTransition={{ timeout: 250 }} centered={true}>
      <ModalHeader>Oops..</ModalHeader>
      <ModalBody>
        {this.state.modalMessage}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => this.toggleModal()}>
          {this.props.t('close')}
        </Button>
      </ModalFooter>
    </Modal>)
  }

  /**
   * React main render method
   */
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          {this._renderModal()}
          {this._renderFormContainer()}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loginReducer.loading,
  error: state.loginReducer.error,
  loading_project: state.projectReducer.loading
});

const mapDispatchToProps = {
  verify,
  sendVerificationCode,
  changePassword,
  resetPassword,
  verifyCode,
  setPassword,
  logout
};

export default compose(withTranslation('common'), connect(mapStateToProps, mapDispatchToProps))(ResetPassword);
